import { store } from '@/store';
import api from '@api/Api';

export default {

    getConnection(id) {
        return api().get(`/connections/${id}`);
    },

    updateConnection(id, params) {
        return api().put(`/connections/${id}`, params);
    },

    refreshConnection(id) {
        return api().get(`/connections/${id}/refresh`);
    },

    syncConnection(id, params) {
        return api().post(`/connections/${id}/sync`, params).then((response) => {
            store.commit('setProject', response.data.data);
            return response;
        });
    },

    deleteConnection(id) {
        return api().delete(`/connections/${id}`).then((response) => {
            store.commit('setProject', response.data.data);
            return response;
        });
    },

}